import React, {useEffect, useState} from 'react';

import { useSelector,useDispatch } from 'react-redux';
import {getActivityData, setActivitySelectData} from "../VoteActivity/store/actionCreators";
import {Container} from "./style";
import {Button, Ellipsis, Empty, NavBar, Search, Space, Toast} from "antd-mobile";
import {List,Badge} from "antd";
import {getHeaderData} from "../Header/store/actionCreators";
import {setMainTabbarData} from "../Main/store/actionCreators";
import {getUserInfoData} from "../User/store/actionCreators";
import {checkPhone, isBlank, isNotBlank} from "../../util/StringUtil";
import myRequest from "../../request";
import axios from "axios";
import $axios from "../../request";

export default function ActivityList(props){
    let tktype = false;//不要使用State,会发生嵌套异常
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState('');
    const [state, setState] = useState('');
    const [openId, setOpenId] = useState('');
    const search = props.location.search.substring(1); //截取local,并删除第一个?号字符
    console.log('search',search)
    Toast.show('登录中');
    if (isNotBlank(search)) {

        const searchs = search.split('&');

        searchs.map(item =>{
            const valArr = item.split('=');
            if(valArr.length === 2&&valArr[0] === 'code'){
               setCode(valArr[1])
            }else if(valArr.length === 2&&valArr[0] === 'state'){
                setState(valArr[1])
            }else if(valArr.length === 2&&valArr[0] === 'openId'){
                setOpenId(valArr[1])
            }
        })
        if(openId != ''){
            onSubmitWxLogin()
        }else if(code!==''&&state!==''){
            window.location.href= encodeURI("/goodNetizen/wxLogin/callBack?code="+code+"&state="+state+"&from=https://lottery.jlszhgh.com/wxLogin");
        }else{
            props.history.push('/login');
        }
    } else {
        //props.history.push('/login');
    }

    function onSubmitWxLogin(){
       if(loading){
           return
       }
       setLoading(true);
        let url = '/wxLogin/login';
        //let url = '/login';
        $axios.getRequest(url,{openId})
            .then((response) => {


                if (response.succeed) {
                    const token = response?.data?.user?.token
                    if(token){
                        //Toast.show('登录成功');
                        $axios.setAuthToken(token);
                        console.log('props.history',props.history);
                        setTimeout(
                            () => {
                                window.location.href= '/';
                            },
                            500
                        );
                    }else{
                        Toast.show('登录失败');
                    }


                }else{

                }
                setLoading(false);
            })
            .catch((error) => {
                console.log(url, error);
                Toast.show('登录失败');
                setLoading(false);
            });
    }


    return (
        <>

        </>
    );


}
